// extracted by mini-css-extract-plugin
export default {"sectorText":"Footer_sectorText__6zDu3","nemad":"Footer_nemad__CTTvK","logo":"Footer_logo__w79hm"};